import InstantSearchInput from '@/components/InstantSearchInput';
import { PageAudienceFilter } from '@/components/page';
import { PendoPlaceholder } from '@/components/PendoPlaceholder';
import ShareMenu from '@/features/ShareMenu';

const OpportunitiesOverviewActions = () => {
  return (
    <div className="flex flex-wrap items-center justify-end gap-2">
      <PendoPlaceholder />
      <div className="flex items-center gap-2">
        <PageAudienceFilter />
        <ShareMenu notificationPageKey="opportunities" />
      </div>
      <InstantSearchInput className="max-w-75" />
    </div>
  );
};

export default OpportunitiesOverviewActions;
